var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"px-6 py-3 text-sm font-medium text-white rounded-lg shadow-lg bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500",on:{"click":_vm.fireAction}},[_vm._v("\n  Toggle Theme\n")])}
var staticRenderFns = []

export { render, staticRenderFns }